import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from "moment";

var Glyphicon = require("components/utility/icons/Glyphicon");
var BraveCheckbox = require("components/utility/BraveCheckbox");
var LoadingButton = require("components/utility/LoadingButton");
var DropDownOptions = require("components/utility/DropDownOptions");
var UpgradeTokenFormModal = require("components/appdev/wizards/UpgradeTokenFormModal");
var AccountPlans = require("lib/account/AccountPlans");
var CurrentUser = require("lib/account/CurrentUser");

require("appdev/wizards/school_org_accounts_page.scss");

class SchoolOrgAccountsPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			checked: {},
			lastIDChecked: null,
			loading: false,
			showSelectByEmail: false,
			selectByEmailText: "",

			accountChanges: {}

			// newNextCharge: moment().format("YYYY-MM-DD"),
			// emailRenewalNotice: false,
			// upgradePlanType: AccountPlans.GOLD_PLAN
		};
	}

	openUpgradeTokenFormModal(e) {
		$wr.nope(e)
		this.refs.upgradeTokenFormModal.show();
	}

	toggleSelectByEmail(e) {
		$wr.nope(e);
		this.setState({ showSelectByEmail: !this.state.showSelectByEmail });
	}

	adminsChecked() {
		return Object.keys(this.state.checked).filter(key => this.state.checked[key])
	}

	submitSelectByEmail(e) {
		$wr.nope(e);

		var emails = this.state.selectByEmailText.split(/(\n|,)/g).
			filter(x => x.includes("@")).
			map(x => x.trim().toLowerCase());

		var newChecked = _.clone(this.state.checked);
		this.admins().forEach((admin) => {
			if (emails.includes(admin.email)) {
				newChecked[admin.id] = true;
			}
		});

		this.setState({
			checked: newChecked,
			showSelectByEmail: false,
			selectByEmailText: ""
		});
	}

	inactiveAdminIDs() {
		var adminIDs = [];

		this.admins().forEach((admin) => {
			if (!admin.account.plan_type) {
				adminIDs.push(admin.id);
			}
		});

		return adminIDs;
	}

	applyToAccounts() {
		var accounts = {};
		_.each(this.state.checked, (isChecked, id) => {
			if (isChecked) {
				accounts[id] = {};

				_.each(this.state.accountChanges, (val, key) => {
					if (key !== undefined) {
						accounts[id][key] = val;
					}
				})				
			}
		})

		this.patchAccounts(accounts);
	}

	upgradeAccounts() {

	}

	removeInactiveAccounts() {
		if (confirm("Remove inactive accounts from the school org?")) {
			var accounts = {};
			_.each(this.inactiveAdminIDs(), (id) => {
				accounts[id] = { remove_from_school_org: true };
			})

			this.patchAccounts(accounts);
		}
	}

	deactivateAccounts() {
		if (confirm("Are you sure you want to deactivate these accounts?")) {
			var accounts = {};
			_.each(this.state.checked, (isChecked, id) => {
				if (isChecked) {
					accounts[id] = { deactivate: true }					
				}
			})

			this.patchAccounts(accounts);			
		}
	}
	patchAccounts(accounts) {
		var params = {
			school_org: { accounts }
		}

		this.setState({ loading: true });

		CurrentUser.api().patchSchoolOrg(this.props.schoolOrg.id, params, $wr.apiHandler((response) => {
			this.setState({ loading: false });
			this.props.fetchSchoolOrgDetailsF(true);
		}));
	}

	onCheckRow(selectedAdminID, e) {
		var newChecked = _.clone(this.state.checked);
		if (e.shiftKey && this.state.lastIDChecked) {
			var inRange = false;
			_.each(this.admins(), (admin) => {
				if (admin.id == selectedAdminID || admin.id == this.state.lastIDChecked) {
					inRange = !inRange; // Toggle it first to true (1st one) then false (2nd one)
					newChecked[admin.id] = true;
				} else if (inRange) {
					newChecked[admin.id] = newChecked[admin.id] || inRange;					
				}
			})
		} else {
			newChecked[selectedAdminID] = !this.state.checked[selectedAdminID];
		}

		this.setState({
			checked: newChecked,
			lastIDChecked: selectedAdminID
		})

	}

	onCheckAllAdmins(e) {
		$wr.nope(e)
		var admins = this.admins()
		var newChecked = {}
		if (_.size(admins) != _.size(this.state.checked)) {
			_.each(admins, a => { newChecked[a.id] = true })
		}

		this.setState({ checked: newChecked })

	}

	admins() {
		var admins = [].concat(
			this.props.schoolOrg.admins,
			this.props.schoolOrg.teachers
		);

		return _.sortBy(admins, a => [a.role, a.last_name, a.first_name].join("__"))
	}

	selectedCount() {
		return (_.reduce(_.values(this.state.checked), (m, x) => m + x) || 0) + 0;
	}

	renderAccountChange(key) {
		var currentValue = this.state.accountChanges[key];
		var isActive = currentValue !== undefined;


		var setValue = (x) => {
			this.setState({
				accountChanges: { ...this.state.accountChanges, [key]: x }
			});
		};

		if (this.state.accountChanges[key] !== undefined) {
			var onToggle = () => setValue(undefined);
		} else {
			var onToggle = () => setValue(defaultValue);
		}

		if (key === "next_charge") {
			var defaultValue = moment().format("YYYY-MM-DD");

			var input = (
				<DatePicker className="form-control"
					disabled={ !isActive }
					selected={ moment(currentValue || defaultValue) }
					onChange={ (date) => setValue(date.format("YYYY-MM-DD")) } />	
			);

		} else if (key === "plan_type") {
			var defaultValue = AccountPlans.GOLD_PLAN;
			var input = (
				<select className="form-control"
					disabled={ !isActive }
					value={ currentValue || defaultValue }
					onChange={ (e) => setValue(e.target.value) }>

					{ DropDownOptions.Select.PaidPlanOptions() }
				</select>
			);

		} else if (key === "student_list_count") {
			var defaultValue = 1;

			var input = (
				<input className="form-control" type="number"
					disabled={ !isActive }
					value={ currentValue || "" }
					onChange={ (e) => setValue(e.target.value) } />
			);

		} else if (key === "has_rlds" || key === "send_renewal_notice") {
			var defaultValue = false;

			var input = (
				<select className="form-control"
					disabled={ !isActive }
					value={ currentValue || defaultValue }
					onChange={ (e) => setValue(e.target.value.toString() === "true") }>

					{ DropDownOptions.Select.YesNo() }
				</select>
			);
		}

		return (
			<div>
				<label>
					<input type="checkbox" value={ isActive } onClick={ onToggle } />

					{ " " } Change { key }
				</label><br />
				{ input }
			</div>
		);
	}

	render() {
		var rows = this.admins().map((admin) => {
			var primaryStudentListCount = this.props.schoolOrg.active_student_lists.filter(
				(x) => x.primary_admin && ((x.primary_admin || {}).id === admin.id)
			).length;

			if ((admin.id === (this.props.schoolOrg.primary_admin || {}).id) || primaryStudentListCount) {
				var roleMarker = (
					<Glyphicon icon="asterisk" className="smallText" />
				);
			}

			if (admin.account.product) {
				var checkbox = (
					<BraveCheckbox value={ !!this.state.checked[admin.id] }
						onClick={ this.onCheckRow.bind(this, admin.id) } />
				);
			}

			if (admin.account.has_credit_card) {
				var hasCreditCardIndicator = (
					<div className="smallText">
						Has Credit Card
					</div>
				)
			}

			return (
				<tr key={ admin.id }>
					<td>
						{ checkbox }
					</td>
					<td>
						<Link to={ '/users/' + admin.id + '/details' }>
							{ admin.first_name } { admin.last_name } ({ admin.id })
						</Link>
						<div className="smallText">
							{ admin.email }
						</div>
					</td>
					<td>
						{ admin.account.product } { admin.account.plan_has_rlds ? "+ RLDs" : "" }
					</td>
					<td>
						{ admin.role } { roleMarker }
					</td>
					<td>
						{ primaryStudentListCount } / { admin.account.max_student_list_count || "-" }
					</td>
					<td>
						{ $wr.formatDate(admin.account.next_charge_time) }
						{ hasCreditCardIndicator }
					</td>
				</tr>
			);
		})

		if (this.state.showSelectByEmail) {
			var selectByEmailContent = (
				<div>
					<textarea className="form-control"
						value={ this.state.selectByEmailText }
						placeholder="Emails separated by lines or commas"
						onChange={ (e) => this.setState({ selectByEmailText: e.target.value }) } />

					<div className="text-right">
						<a href="#" onClick={ this.submitSelectByEmail } >
							Select!
						</a>
					</div>
				</div>
			)
		}

		var accountText = $wr.pluralizeWithNumber("account", this.selectedCount());
		var upgradeTokenForm = <UpgradeTokenFormModal ref='upgradeTokenFormModal' schoolOrg={this.props.schoolOrg} adminIDs={this.adminsChecked()} />

		return (
			<div className="schoolOrgAccountsPage">
				<div className="controls">
					<div className="row">
						<div className="col-sm-4">
							{ this.renderAccountChange("next_charge") }
						</div>
						<div className="col-sm-4">
							{ this.renderAccountChange("plan_type") }
						</div>
						<div className="col-sm-4">
							{ this.renderAccountChange("student_list_count") }
						</div>
					</div>

					<div className="row">
						<div className="col-sm-4">
							{ this.renderAccountChange("has_rlds") }
						</div>
						<div className="col-sm-4">
							{ this.renderAccountChange("send_renewal_notice") }
						</div>
						<div className="col-sm-4">
						</div>
					</div>

					<div className="clearfix">
						<LoadingButton loading={ this.state.loading }
							disabled={ this.inactiveAdminIDs().length < 1 }
							text={ "Remove " + this.inactiveAdminIDs().length + " Inactive" }
							onClick={ this.removeInactiveAccounts }
							className="btn btn-danger pull-left" />
						
						<LoadingButton loading={ this.state.loading }
							disabled={ this.selectedCount() < 1 }
							text={ "Upgrade " + accountText }
							onClick={ this.openUpgradeTokenFormModal }
							className="btn buttonPrimary pull-left" />

						<LoadingButton loading={ this.state.loading }
							disabled={ this.selectedCount() < 1 }
							text={ "Apply to " + accountText }
							onClick={ this.applyToAccounts }
							className="btn buttonPrimary pull-right" />

						<LoadingButton loading={ this.state.loading }
							disabled={ this.selectedCount() < 1 }
							text={ "Deactivate " + accountText }
							onClick={ this.deactivateAccounts }
							className="btn btn-danger pull-right" />
					</div>
				</div>
				<p>
					Inactive accounts need to be upgraded using the Upgrade Token system.
				</p>
				<div className="selectByEmail">
					<a href="#" onClick={ this.toggleSelectByEmail } className="toggleLink">
						Toggle Select By Email
					</a>
					{ selectByEmailContent }
				</div>
				<table className="table">
					<tbody>
						<tr>
							<th>
								<BraveCheckbox value={_.size(this.adminsChecked()) && _.size(this.adminsChecked()) == _.size(this.admins())}
									onClick={this.onCheckAllAdmins} />
							</th>
							<th>Admin</th>
							<th>Product</th>
							<th>Role</th>
							<th>Primary Classes</th>
							<th>Next Charge</th>
						</tr>
						{ rows }
					</tbody>
				</table>
				<div className="smallText">
					<Glyphicon icon="asterisk" className="smallText" /> Indicates primary teacher/admin
				</div>
				{upgradeTokenForm}
			</div>
		);
	}
};

SchoolOrgAccountsPage.propTypes = PageStrictPropTypes({
	schoolOrg: PropTypes.object.isRequired,
	fetchSchoolOrgDetailsF: PropTypes.func.isRequired,
});

module.exports = SchoolOrgAccountsPage;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/SchoolOrgAccountsPage.js